import React, { PureComponent } from "react";
import ReactDOM from "react-dom";
import { Layer } from "./layer";
import iProps from "./props";
export class Shade extends PureComponent<iProps> {
  private container = document.querySelector("body");
  private html = document.querySelector("html");
  state = {
    el: document.createElement("div"),
  };
  componentDidMount() {
    this.html.style.overflow="hidden";
    this.container && this.container.appendChild(this.state.el);
  }
  componentWillUnmount() {
    this.html.style.overflow="auto";
    this.container && this.container.removeChild(this.state.el);
  }

  render() {
    const { el } = this.state;
    const { props } = this;
    return ReactDOM.createPortal(<Layer {...props}></Layer>, el);
  }
}
const Mask: React.FC<iProps> = React.memo((props) => {
  const { visible = false } = props;
  if (visible) {
    return <Shade {...props}></Shade>;
  } else {
    return null;
  }
});
export default Mask;
